import { render, staticRenderFns } from "./ReasonsToLeave.vue?vue&type=template&id=bc1a8c4e&scoped=true&"
import script from "./ReasonsToLeave.vue?vue&type=script&lang=js&"
export * from "./ReasonsToLeave.vue?vue&type=script&lang=js&"
import style0 from "./ReasonsToLeave.vue?vue&type=style&index=0&id=bc1a8c4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1a8c4e",
  null
  
)

export default component.exports